import { render } from "./editpurchasereturn.vue?vue&type=template&id=412e9384"
import script from "./editpurchasereturn.vue?vue&type=script&lang=js"
export * from "./editpurchasereturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__